import { render } from "./DeleteAvatar.vue?vue&type=template&id=96d8bf72"
import script from "./DeleteAvatar.vue?vue&type=script&lang=js"
export * from "./DeleteAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__